import { IField } from '@shared/model';;
import { JournalRecordAction } from '../constants/journal-record-actions';
import { RecordAction } from './journal-record.interface';

export interface ActionHandler {
  execute(entity: any, action: RecordAction): Promise<boolean | void>;
  patch(entity: any, fied: IField): Promise<any>;
  removeAll(): Promise<boolean>;
}
